import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
  getQuestionCategory, 
  addQuestionCategory as postQuestionCategory, 
  updateQuestionCategory as putQuestionCategory, 
  deleteQuestionCategory as removeQuestionCategory,
  activateDeactivateQuestionCategory as activateQuestionCategory,
  uploadImages
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";


// Fetch Table Column Names
export const fetchQuestionCategoryTableColumnNames = createAsyncThunk("questionCategory/fetchTableColumnNames", async (questionCategory, thunkAPI) => {
  try {
    const response = await getHeaders(questionCategory); 
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Fetch All Courses
export const fetchAllQuestionCategory = createAsyncThunk("questionCategory/fetchAll", async (thunkAPI) => {
  try {
    const response = await getQuestionCategory(); 
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Add question
export const createQuestionCategory = createAsyncThunk("questionCategory/add", async (questionCategory, thunkAPI) => {  
  try {
    const response = await postQuestionCategory(questionCategory);
    toast.success(response.message);
    return response;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Update question
export const updateQuestionCategory = createAsyncThunk("questionCategory/update", async (questionCategory, thunkAPI) => {
  try {
    const response = await putQuestionCategory(questionCategory);
    toast.success(response.message);
    return response.data;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Delete question
export const deleteQuestionCategory = createAsyncThunk("questionCategory/delete", async (questionCategory, thunkAPI) => {
  try {
    const response = await removeQuestionCategory(questionCategory);
    toast.success(response.message);
    return response.data;
  } catch (error) {
    toast.error(error.message)
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Activate deactivate referral reward 
export const activateDeactivateQuestionCategory = createAsyncThunk("questionCategory/activateDeactivate", async (questionCategory, thunkAPI) => {
  try {
    const response = await activateQuestionCategory(questionCategory);
    toast.success(response.message);
    return response.data;
  } catch (error) {
    toast.error(error.message)
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

export const uploadQuestionCategoryIcon = createAsyncThunk("questionCategory/icon", async (questionCategory, thunkAPI) => {
  try {
    const response = await uploadImages(questionCategory); 
    return response.Data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});